import { useState } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { breakpoints } from '@frontend/responsiveness';
import { useAppScopeStore } from '@frontend/scope';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';
import { trackingIds } from '../../../../tracking-ids';

export const StatusMappingBanner = () => {
  const { t } = useTranslation('analytics');
  const [show, setShow] = useState<boolean>(true);
  const { selectedLocationIds = [] } = useAppScopeStore();
  const { navigate } = useSettingsNavigate();

  const handleNavigateToStatusMappingSettings = () => {
    if (selectedLocationIds.length > 1) {
      navigate({
        to: '/organization/data-sync',
      });
    } else {
      navigate({
        to: '/organization/data-sync/location/:locationId',
        params: {
          locationId: selectedLocationIds[0],
        },
      });
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div css={styles.mainWrapper}>
      <Icon name='alert-filled' style={{ minWidth: theme.spacing(3) }} />
      <div css={styles.contentWrapper}>
        <div>
          <Heading level={3} style={{ fontSize: theme.font.size.large }}>
            {t('Improve Appointment Data Accuracy')}
          </Heading>
          <Text>{t('Map your appointment statuses to keep your data consistent and insights accurate.')}</Text>
        </div>
        <Button
          onClick={handleNavigateToStatusMappingSettings}
          trackingId={trackingIds.roi.noShowRateUpdateMapping}
          variant='tertiary'
        >
          {t('Update Mapping')}
        </Button>
      </div>
      <Button iconName='x' onClick={() => setShow(false)} size='large' variant='secondary' />
    </div>
  );
};

const styles = {
  mainWrapper: css`
    background-color: ${theme.colors.warning5};
    box-shadow: ${theme.shadows.light};
    display: flex;
    gap: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(0.5)};
    padding: ${theme.spacing(2)};

    @container (min-width: ${breakpoints.mobile.max}px) {
      align-items: center;
    }
  `,

  contentWrapper: css`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: ${theme.spacing(1)};
    justify-content: flex-start;

    @container (min-width: ${breakpoints.mobile.max}px) {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }

    > button {
      width: fit-content;
    }
  `,
};
